import { render } from "./PlayerDemographicsAnalysis.vue?vue&type=template&id=44d72d10&scoped=true"
import script from "./PlayerDemographicsAnalysis.vue?vue&type=script&lang=js"
export * from "./PlayerDemographicsAnalysis.vue?vue&type=script&lang=js"

import "./PlayerDemographicsAnalysis.vue?vue&type=style&index=0&id=44d72d10&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44d72d10"]])

export default __exports__